import React,{useState, useEffect, useRef, useContext} from "react";

import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

import LogoutPage from './Logout';


import { ThemeContext } from "../../../context/ThemeContext";
import MenuToggleButton from "./MenuToggleButton";

const notifications = [
	{ title: 'Nouvelle tentative soumise par Amadou Diallo', time: "À l'instant", icon: 'ti ti-send', color: 'primary' },
	{ title: 'Résultats du QCM de Chimie publiés', time: 'Il y a 10 min', icon: 'ti ti-report', color: 'success' },
	{ title: 'Réclamation en attente de traitement', time: 'Il y a 2 h', icon: 'ti ti-alert-circle', color: 'warning' },
];

const Header2 = ({ onNote }) => {
  //For header fixed
	const [headerFix, setheaderFix] = useState(false);
	useEffect(() => {
		window.addEventListener("scroll", () => {
			setheaderFix(window.scrollY > 50);
		});
	}, []);


	const {background, changeBackground } = useContext(ThemeContext);
	const handleThemeMode = () => {
		if(background.value === 'dark'){
			changeBackground({ value: "light", label: "Light" });
		}else{
			changeBackground({ value: "dark", label: "Dark" });
		}
	}
	const [profileOpen, setProfileOpen] = useState(false);
	const profileRef = useRef(null);
	useEffect(() => {
		const handleClickOutside = (e) => {
			if (profileRef.current && !profileRef.current.contains(e.target)) {
				setProfileOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);
	var path = window.location.pathname.split("/");
	var name = path[path.length - 1].split("-");
	var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
	var finalName = filterName.includes("app")
	  ? filterName.filter((f) => f !== "app")
	  : filterName.includes("ui")
	  ? filterName.filter((f) => f !== "ui")
	  : filterName.includes("uc")
	  ? filterName.filter((f) => f !== "uc")
	  : filterName.includes("basic")
	  ? filterName.filter((f) => f !== "basic")
	  : filterName.includes("jquery")
	  ? filterName.filter((f) => f !== "jquery")
	  : filterName.includes("table")
	  ? filterName.filter((f) => f !== "table")
	  : filterName.includes("page")
	  ? filterName.filter((f) => f !== "page")
	  : filterName.includes("email")
	  ? filterName.filter((f) => f !== "email")
	  : filterName.includes("ecom")
	  ? filterName.filter((f) => f !== "ecom")
	  : filterName.includes("chart")
	  ? filterName.filter((f) => f !== "chart")
	  : filterName.includes("editor")
	  ? filterName.filter((f) => f !== "editor")
	  : filterName;
  return (
	<div className={`header tw-bg-white dark:tw-bg-[#272738] ${ headerFix ? "sticky" : ""}`}>
	  <div className="header-content pt-3 pb-3">
		<nav className="navbar navbar-expand">
		  <div className="collapse navbar-collapse justify-content-between">
			<div className="header-left d-flex align-items-center">
				<MenuToggleButton />
				<div className="dashboard_bar tw-capitalize tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-white">
					{finalName.join(" ").length === 0
					  ? "Dashboard"
					  : finalName.join(" ") === "dashboard dark"
					  ? "Dashboard"
					  : finalName.join(" ")}
				</div>
			</div>
			<ul className="navbar-nav header-right align-items-center">
				<li className="nav-item dropdown notification_dropdown">
					<Link to={"#"} className={`nav-link bell dz-theme-mode ${background.value === "dark" ? "active" : ""}`}
						onClick={()=>handleThemeMode()}
					>
						<i id="icon-light-1">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-sun"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
						</i>
						<i id="icon-dark-1">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-moon"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
						</i>
					</Link>
				</li>

				{/* <Dropdown as="li" className="nav-item notification_dropdown">
					<Dropdown.Toggle as="a" className="nav-link bell i-false c-pointer position-relative">
						<i className="ti ti-bell fs-20"></i>
						<span className="badge bg-danger rounded-circle position-absolute" style={{ width: 8, height: 8, top: 8, right: 8, padding: 0 }}></span>
					</Dropdown.Toggle>
					<Dropdown.Menu align="end" className="dropdown-menu-end p-0" style={{ minWidth: 320 }}>
						<div className="p-3 border-bottom">
							<h6 className="mb-0">Notifications</h6>
						</div>
						{notifications.map((notif, index) => (
							<Dropdown.Item key={index} as={Link} to="#" className="d-flex align-items-center py-2">
								<span className={`avatar avatar-sm bg-${notif.color}-transparent rounded-circle me-2 d-flex align-items-center justify-content-center flex-shrink-0`}>
									<i className={`${notif.icon} text-${notif.color} fs-14`}></i>
								</span>
								<div className="overflow-hidden">
									<p className="mb-0 text-truncate">{notif.title}</p>
									<small className="text-muted">{notif.time}</small>
								</div>
							</Dropdown.Item>
						))}
					</Dropdown.Menu>
				</Dropdown> */}

				<li className="nav-item tw-relative" ref={profileRef}>
					<button
						type="button"
						onClick={() => setProfileOpen((o) => !o)}
						className="nav-link i-false c-pointer ms-0 tw-flex tw-items-center tw-gap-2 tw-bg-transparent tw-border-0"
					>
						<div className="header-info2 d-flex align-items-center">
							<img src="" alt="" className="tw-w-9 tw-h-9 tw-rounded-full tw-object-cover" />
						</div>
					</button>
					{profileOpen && (
					<div className="profile-dropdown-panel pt-6">
						<div className="card mb-0 shadow-none border-0">
							<div className="card-header p-3">
								<ul className="d-flex align-items-center">
									<li>
										<img src="" className="ms-0 tw-w-10 tw-h-10 tw-rounded-full tw-object-cover" alt="" />
									</li>
									<li className="ms-2">
										<h4 className="mb-0 tw-text-gray-800 dark:tw-text-white">Nella Vita</h4>
										<span className="tw-text-gray-400">Admin</span>
									</li>
								</ul>

							</div>
								<div className="card-footer text-center p-3">
									<LogoutPage />
								</div>
							</div>
					</div>
					)}
				</li>
			</ul>
		  </div>
		</nav>
	  </div>
	</div>
  );
};

export default Header2;
